import _defineProperty from "/var/lib/jenkins/workspace/workspace/mr-learner-frontend-production-china/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { genComponentStyleHook } from '../../theme/internal'; // =============================== Base ===============================

var genBaseStyle = function genBaseStyle(token) {
  var componentCls = token.componentCls,
      colorText = token.colorText,
      fontSize = token.fontSize,
      lineHeight = token.lineHeight,
      fontFamily = token.fontFamily;
  return _defineProperty({}, componentCls, {
    color: colorText,
    fontSize: fontSize,
    lineHeight: lineHeight,
    fontFamily: fontFamily
  });
}; // ============================== Export ==============================


export default genComponentStyleHook('App', function (token) {
  return [genBaseStyle(token)];
});